//外部引用了 此处不需要打包到主js内了
//import axios from 'axios'

//HCUser 存用户id tooken 等信息
//HCSecret 存手机号密码等
import Vue from 'vue'
import qs from 'qs'
import main from '../../main.js'
//接口路径
const URL_ = window.location.origin=='https://admin.myhechang.cn'?'https://www.myhechang.cn':'http://dev.myhechang.cn';	
export default{
	commonUrl:URL_,
	solgan:'家族传承在线学习平台',
	shareLogo:URL_+'/mobile/commonpic/logo.png',
	isUpYun:false,		//是否进行upyun上传了
	PageSize:50,
	data() {
		return {
			isQiNiu:false,			//是否正在进行axios请求
			source:null,				//存请求的
		}
	},
	phoneInputListening:function(val){		//只能输入11位数字
		var reg = val.match(/\d{0,11}/);
		var txt = '';
		if(reg != null) {
			txt = reg[0];
		}
		return txt;
	},
	testPhoneNume:function(val){			//	手机号正则表达式
		var myreg = /^\d{1,11}$/;		
//		var myreg = /^1\d{10}$/;		
		var isTrue=false;
		if(val && myreg.test(val)){	
			isTrue=true;
		}
		return isTrue;
	},
	getPageHeight:function(){
		return document.documentElement.clientHeight;
	},
	getPageWidth:function(){
		return document.documentElement.clientWidth;
	},
	ajax:function(data,url,flag,callback){	//调 测试服 接口
		var that=this;
		var loginToken=this.getCookie('user');			//cookie里存的是否登陆了
			
        if(flag && loginToken){
        	
        		var tokenArr=JSON.parse(loginToken);
			var headToke =tokenArr.token;
			
			axios.defaults.headers.common['AUTHORIZATION'] = headToke;
			
			axios({
				method: 'post',
				url: URL_ + '/myhechang/api/' + url,
				data: qs.stringify(data),
				headers: {
					'AUTHORIZATION': headToke
				},
			}).then(function(response) {
				var result = response.data;
				if(result.code==401){			// 登录凭证不正确
					that.delCookie('user');
					that.logoutFun();
					window.location.reload();
				}else{
					callback(result);
				}
			})
			.catch(function(error) {
				callback(error);
			})
		}else{
			axios({
				method: 'post',
				url: URL_ + '/myhechang/api/' + url,
				data: qs.stringify(data),
			}).then(function(response) {
				var result = response.data;
				callback(result);
			})
			.catch(function(error) {
				console.log(error);
				callback(error);
			})
		}
			
    },
    FilesExport:function(data,url,name){	//调 测试服 接口
		var that=this;
		var loginToken=this.getCookie('user');			//cookie里存的是否登陆了
			
        if(loginToken){
        	
        		var tokenArr=JSON.parse(loginToken);
			var headToke =tokenArr.token;
			
			axios.defaults.headers.common['AUTHORIZATION'] = headToke;
			
			axios({
				method: 'post',
				url: URL_ + '/myhechang/api/' + url,
				data: qs.stringify(data),
				headers: {
					'AUTHORIZATION': headToke
				},
				responseType:"blob",
			}).then(function(res) {
				console.log(res);
				const link = document.createElement("a");
				let blob = new Blob([res.data],{
						type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; application/octet-stream"
					}); //类型excel
				let fileName=res.headers['content-disposition'];
				
				let fileUpName=name?name:'名单';
				if(fileName ){
					let nameArr1=fileName.split('attachment;filename="');
					if(nameArr1.length>1 && nameArr1[1]){
						console.log(nameArr1);
						let nameArr2=nameArr1[1].split('.xlsx"');
						if(nameArr2.length>1){
							fileUpName=nameArr2[0];
						}
					}
					
				}
				console.log(fileUpName);
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download",fileUpName); 
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				
			})
			.catch(function(res) {
				console.log(res);
			})
		}else{
			alert('出错，请刷新页面');
		}
    },
	//终止七牛云的上传
	cancel:function() {
		console.log(this.data.source);
		this.data.source?this.data.source.cancel('cancel'):null;
	},
	//七牛云上传PDF
	upQiNiu:function(uploadData,callback1,callback){	//上传到七牛云调接口
		var that=this;
    		this.data.source=axios.CancelToken.source();
    		that.data.isQiNiu=true;
//  		console.log(this.data.source);
//  		console.log(this.data.source.token);
		const startTime = new Date().getTime();
		axios({
			method: 'POST',
			url: '//up.qbox.me',
			cache: false,
			data: uploadData,
			headers: {
				'Content-Type':'multipart/form-data'
			},
			cancelToken: that.data.source.token,
			onUploadProgress:function(progressEvent){ //原生获取上传进度的事件
//				console.log(progressEvent);
                if(progressEvent.lengthComputable){
                    //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
                    //如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
//                  console.log(progressEvent);
//                  const endTime = new Date().getTime();
//			        const time = (endTime - startTime) / 1000; // 转换为秒
//			        var speed = parseInt((progressEvent.loaded / time)); // 转换为KB/s
//			        var endSpeed;
//			        
//			        
//			        if(speed === 0){
//			        		endSpeed='0 B';
//			        } else{
//			        		var k = 1024; // or 1024
//						var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
//						var i = Math.floor(Math.log(speed) / Math.log(k));
//						endSpeed = (speed / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
//			        }
//			        
//			        console.log(Math.pow(k, i), Math.pow(k, i).toPrecision(3),speed, i,endSpeed);
//			        progressEvent.speeds=endSpeed +'/s';
                    callback1(progressEvent);
                }
            },
		}).then(function(response) {
//			console.log(response);
			var result = response.data;
			that.data.isQiNiu=false;
			callback(result);
		}).catch(function(error) {
//			console.log(error);
			that.data.isQiNiu=false;
			callback(error);
		})
	},
	setCookie:function(name, value){
		var Days = 30;
        var exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString()+';path=/';
	},
	getCookie:function(name){
		var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

        if (arr = document.cookie.match(reg)) return unescape(arr[2]);
        else return null;
	},
	delCookie:function (name) {
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        var cval = this.getCookie(name);
        if (cval != null) document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString()+';path=/';
   },
   logoutFun:function(){		//		清除缓存
		var storage=window.localStorage;
		storage.clear();
	},
	setLocalStorage:function(key,val){
		var storage=window.localStorage;
		storage.setItem(key, val);//		保存数据
	},
	getLocalStorage:function(key){
		var storage=window.localStorage;
		var valuses=storage.getItem(key);//		读取数据
		return valuses;
	},
	trims:function(val){				//判断是不是输入为空	
		if(val){
			var strings=val.replace(/\s+/g,"");
		}else {
			var strings='';
		}
		return strings.length;
	},
	priceListening:function(val,length){			//价格输入，最高10位    length 代表小数点后几位
	
		if(length){
			// 获取输入值
			    let value = val;
			    // 清除非数字和非小数点字符（允许一个点）
			    value = value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
			    
			    // 限制小数点后最多两位
			    if (value.indexOf('.') !== -1) {
			        let parts = value.split('.');
			        if (parts[1].length > 2) {
			            value = parts[0] + '.' + parts[1].substring(0, 2);
			        }
			    }
				return value;
		}else{
			var reg = val.match(/[0]|[1-9]\d{0,10}/);
			var txt = '';
			if(reg != null) {
				txt = reg[0];
			}
			return txt;
			
		}
	},
	NumberListening:function(val){			//价格输入，最高10位
		var reg = val.match(/[0]|[1-9]\d{0,10}/);
		var txt = '';
		if(reg != null) {
			txt = reg[0];
		}
		return txt;
	},
	DataToTimeStamp:function(times){
		return (new Date(times.replace(/-/g,'/')).getTime()/1000);
	},
	getDates:function(nS){		//1970-00-00
		var Times='';
		var ss = new Date(parseInt(nS) * 1000);
		var arr = [];
		arr.push(ss.getFullYear());
		arr.push(ss.getMonth()+1);
		arr.push(ss.getDate());
		Times+=arr[0]+'-'+(arr[1]>9?arr[1]:'0'+arr[1])+'-'+(arr[2]>9?arr[2]:'0'+arr[2]);
		return Times;
	},
	getTimes:function(nS,length){			//00:00   /   00:00:00
		var arr1 = new Date(parseInt(nS) * 1000).toTimeString().split(' ')[0].split(':');
		var result;
		if(length==3){
			result=arr1[0] + ':' + arr1[1] + ':' + arr1[2];
		}else{
			result=arr1[0] + ':' + arr1[1];
		}
		return result;
	},
	getDatasTime:function(nS){  //2019-02-20 13:16:56
		var Times='';
		
		Times=this.getDates(nS)+' '+this.getTimes(nS,3);
		
		return Times;
	},
	renderTime:function (date) {
	  var dateee = new Date(date).toJSON();
	  return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '') 
	},
	dealhtml:function(val){
    		var result=val;
    		result=val.replace(/\r\n/g, '<br/>');//IE9、FF、chrome  
    		result=result.replace(/\n/g, '<br/>'); //IE7-8  
    		result=result.replace(/\s/g, ' '); //空格处理
    		return result;
	},
	judgeContains:function(val){				//判断是否在用户的访问权限内
		var permission_key_arr=main.$store.state.user.permission_key;				//localStorage里登陆用户的信息
		var result=permission_key_arr.includes(val);
		return result;
	},
	dealOperationMenu:function(OperationMenu,value){
		var that=this;
		var result={
			menu:null,
			width:1,
		}
		var checkPermission = function(permissionKey){
			if(!permissionKey) return true;
			return that.judgeContains(permissionKey);
		};
		var dealMenuList = function(menuList,isTopLevel){
			if(!Array.isArray(menuList)) return;
			menuList.forEach(function(menuItem){
				var hasDropdownList = Array.isArray(menuItem.list) && menuItem.list.length > 0;
				var selfActive = checkPermission(menuItem.permission_key);
				if(hasDropdownList){
					dealMenuList(menuItem.list,false);
					var childActive = menuItem.list.some(function(childItem){
						return childItem && childItem.active === true;
					});
					menuItem.active = selfActive || childActive;
				}else{
					menuItem.active = selfActive;
				}
				if(isTopLevel && menuItem.active===true){
					value = value+menuItem.title.length*13+8;
				}
			});
		};
		dealMenuList(OperationMenu,true);
		value>1 ? value+=48 : null;
		
		result.menu=OperationMenu;
		result.width=value;
		return result;
	},
	isOperationDropdown:function(menuItem){
		return !!(menuItem && Array.isArray(menuItem.list) && menuItem.list.length > 0);
	},
	getOperationDropdownList:function(menuItem){
		if(!this.isOperationDropdown(menuItem)) return [];
		return menuItem.list.filter(function(childItem){
			return childItem && childItem.active;
		});
	},
	isImage:function (type) {
	  return /image\/\w+/.test(type);
	},
	smallImg:function(img){
	/*	var oldImg=img.split('!/crop/');
		
		var newImg='';
		if(oldImg && oldImg.length>1){
			for(var i=0;i<oldImg.length;i++){
				if(i==0){
					newImg=oldImg[i]+'!small';
				}else{
					newImg =newImg+'/crop/'+oldImg[i];
				}
			}
		}
		
		var type2=img.split('?');
		console.log(type2);
		if(type2 && type2.length>1){
			for(var i=0;i<type2.length;i++){
				if(i==0){
					newImg=type2[i]+'!small';
				}else{
					newImg =newImg+'?'+type2[i];
				}
			}
		}else{
			newImg=img+'!small';
		}
		
		if(newImg && newImg!=''){
			console.log(newImg);
			return newImg;
		}else{
			console.log(img);
			return img
		}*/
		return img
		
	},
	formatDuration: function(duration) {
		// 如果duration为空或null，返回1分钟
		if (!duration || duration <= 0) {
			return '1分钟';
		}
		
		// 假设duration是以秒为单位
		var totalSeconds = parseInt(duration);
		var hours = Math.floor(totalSeconds / 3600);
		var minutes = Math.floor((totalSeconds % 3600) / 60);
		
		// 如果不到1分钟，显示1分钟
		if (totalSeconds < 60) {
			return '1分钟';
		}
		
		// 如果有小时，显示"xx小时xx分钟"
		if (hours > 0) {
			return hours + '小时' + minutes + '分钟';
		} else {
			// 只有分钟，显示"xx分钟"
			return minutes + '分钟';
		}
	}
}


// WEBPACK FOOTER //
// ./src/assets/js/common.js